import { RefObject, useEffect, useState } from 'react';

export const useTooltipEllipsis = (initialText: string, ref: RefObject<HTMLElement>) => {
    const [isOverflowing, setIsOverflowing] = useState(false);

    useEffect(() => {
        const checkOverflow = () => {
            const element = ref.current;
            if (element) {
                setIsOverflowing(element.offsetWidth < element.scrollWidth);
            }
        };

        checkOverflow();
        window.addEventListener('resize', checkOverflow);

        return () => {
            window.removeEventListener('resize', checkOverflow);
        };

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [initialText]);

    return isOverflowing;
};
